import { render, staticRenderFns } from "./ViewLicense.vue?vue&type=template&id=5a6b74f4&scoped=true&"
import script from "./ViewLicense.vue?vue&type=script&lang=js&"
export * from "./ViewLicense.vue?vue&type=script&lang=js&"
import style0 from "./ViewLicense.vue?vue&type=style&index=0&id=5a6b74f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6b74f4",
  null
  
)

export default component.exports